import { useTranslation } from "react-i18next";

export const PAGE_ID = {
    DASHBOARD: '9f256bd5-c54c-11f0-800f-42010a8e000b',
    MIS_CHECKLIST: '9f401e39-c54c-11f0-800f-42010a8e000b',
    RESPUESTAS_CHECKLIST: '9f5a9649-c54c-11f0-800f-42010a8e000b',
    USUARIOS_WEB: '9f754608-c54c-11f0-800f-42010a8e000b',
    USUARIOS_MOVIL: '9f90239c-c54c-11f0-800f-42010a8e000b',
    GESTIONAR_OPCION_RESPUESTA: '9faaeed2-c54c-11f0-800f-42010a8e000b',
    GESTIONAR_CORREOS: '9fc55651-c54c-11f0-800f-42010a8e000b',
    GESTIONAR_TIPO_CHECKLIST: '9fe017e4-c54c-11f0-800f-42010a8e000b',
    GESTIONAR_ICONOS: '9ffae1f8-c54c-11f0-800f-42010a8e000b',
    GESTIONAR_CIUDAD: 'a015bd8a-c54c-11f0-800f-42010a8e000b',
    GESTIONAR_AREA: 'a03046cc-c54c-11f0-800f-42010a8e000b',
    GESTIONAR_MARCA_VEHICULO: 'a04af750-c54c-11f0-800f-42010a8e000b',
    GESTIONAR_TIPO_COMBUSTIBLE: 'a065d2c0-c54c-11f0-800f-42010a8e000b',
    GESTIONAR_TIPO_VEHICULO: 'a080abc0-c54c-11f0-800f-42010a8e000b',
    GESTIONAR_TIPO_CARROCERIA: 'a09b66ae-c54c-11f0-800f-42010a8e000b',
    GESTIONAR_TIPO_USUARIO_MOVIL: 'a0b641fa-c54c-11f0-800f-42010a8e000b',
    GESTIONAR_SUB_TIPO_USUARIO_WEB: 'a0d11bd5-c54c-11f0-800f-42010a8e000b',
    GESTIONAR_NIVEL_COMBUSTIBLE: 'a0eba8da-c54c-11f0-800f-42010a8e000b',
    GESTIONAR_PIE_DE_PAGINA: 'a10656ce-c54c-11f0-800f-42010a8e000b',
    GESTIONAR_MOTIVO: 'a1211320-c54c-11f0-800f-42010a8e000b',
    GESTIONAR_TELEFONO: 'a13bed8b-c54c-11f0-800f-42010a8e000b',
    CONSOLIDADO_RESPUESTAS_CHECKLIST: '58233128-c54d-11f0-800f-42010a8e000b',
    GESTIONAR_ALERTA_OPCION_RESPUESTA_PLACA: '2f69896b-03b6-11f1-800f-42010a8e000b',
    GESTIONAR_PERSONAL_TRANSPORTAR: 'e7f8101b-0dc2-11f1-a30f-42010a8e000b',
    GESTIONAR_RUTA: '0d3a6392-0de8-11f1-a30f-42010a8e000b',
    GESTIONAR_PERSONA: '8ec1dd13-0e00-11f1-a30f-42010a8e000b',
    GESTIONAR_RIESGO: '18240d4b-0e00-11f1-a30f-42010a8e000b',
    GESTIONAR_TURNO: '46361e6e-0e76-11f1-a30f-42010a8e000b',
    GESTIONAR_ESTADO_VIAJE: '1978c34e-380d-11f1-a30f-42010a8e000b',
};

export const usePages = () => {
    const { t } = useTranslation();
    const LISTA_PAGES = [
        {
            checked: false,
            value: PAGE_ID.DASHBOARD,
            label: t('menu_dashboard'),
            acciones: [
                {
                    value: 'btn_ver',
                    label: t('btn_ver'),
                    checked: false,
                },
                {
                    value: 'btn_buscar',
                    label: t('btn_buscar'),
                    checked: false,
                },
                {
                    value: 'btn_compartir',
                    label: t('btn_compartir'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.MIS_CHECKLIST,
            label: t('menu_mis_checklist'),
            acciones: [
                {
                    value: 'btn_formulario',
                    label: t('btn_formulario'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
                {
                    value: 'btn_alertas',
                    label: t('btn_alertas'),
                    checked: false,
                },
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_viaje',
                    label: t('btn_viaje'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.RESPUESTAS_CHECKLIST,
            label: t('titulo_respuestas_checklist'),
            acciones: [
                {
                    value: 'btn_buscar',
                    label: t('btn_buscar'),
                    checked: false,
                },
                {
                    value: 'btn_ver',
                    label: t('btn_ver'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.USUARIOS_WEB,
            label: t('menu_usuarios_web'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_buscar',
                    label: t('btn_buscar'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
                {
                    value: 'btn_habilitar',
                    label: t('btn_habilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.USUARIOS_MOVIL,
            label: t('menu_usuarios_movil'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_buscar',
                    label: t('btn_buscar'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
                {
                    value: 'btn_habilitar',
                    label: t('btn_habilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_OPCION_RESPUESTA,
            label: t('titulo_gestionar_opcion_respuesta'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_CORREOS,
            label: t('titulo_gestionar_correos'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_TIPO_CHECKLIST,
            label: t('titulo_gestionar_tipo_checklist'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                }
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_ICONOS,
            label: t('titulo_gestionar_iconos'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_CIUDAD,
            label: t('titulo_gestionar_ciudad'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_AREA,
            label: t('titulo_gestionar_area'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_MARCA_VEHICULO,
            label: t('titulo_gestionar_marca_vehiculo'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_TIPO_COMBUSTIBLE,
            label: t('titulo_gestionar_tipo_combustible'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_TIPO_VEHICULO,
            label: t('titulo_gestionar_tipo_vehiculo'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_TIPO_CARROCERIA,
            label: t('titulo_gestionar_tipo_carroceria'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_TIPO_USUARIO_MOVIL,
            label: t('titulo_gestionar_tipo_usuario_movil'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_SUB_TIPO_USUARIO_WEB,
            label: t('titulo_gestionar_sub_tipo_usuario_web'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
                {
                    value: 'btn_permisos',
                    label: t('btn_permisos'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_NIVEL_COMBUSTIBLE,
            label: t('titulo_gestionar_nivel_combustible'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_PIE_DE_PAGINA,
            label: t('titulo_gestionar_pie_de_pagina'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_formulario',
                    label: t('btn_formulario'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_MOTIVO,
            label: t('titulo_gestionar_motivo'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_TELEFONO,
            label: t('titulo_gestionar_telefono'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.CONSOLIDADO_RESPUESTAS_CHECKLIST,
            label: t('titulo_consolidado_respuestas_checklist'),
            acciones: [
                {
                    value: 'btn_buscar',
                    label: t('btn_buscar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_ALERTA_OPCION_RESPUESTA_PLACA,
            label: t('titulo_gestionar_alerta_opcion_respuesta_placa'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_PERSONAL_TRANSPORTAR,
            label: t('titulo_gestionar_personal_transportar'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_RUTA,
            label: t('titulo_gestionar_ruta'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_PERSONA,
            label: t('titulo_gestionar_persona'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_RIESGO,
            label: t('titulo_gestionar_riesgo'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_TURNO,
            label: t('titulo_gestionar_turno'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
            ],
        },
        {
            checked: false,
            value: PAGE_ID.GESTIONAR_ESTADO_VIAJE,
            label: t('titulo_gestionar_estado_viaje'),
            acciones: [
                {
                    value: 'btn_nuevo',
                    label: t('btn_nuevo'),
                    checked: false,
                },
                {
                    value: 'btn_modificar',
                    label: t('btn_modificar'),
                    checked: false,
                },
                {
                    value: 'btn_deshabilitar',
                    label: t('btn_deshabilitar'),
                    checked: false,
                },
                {
                    value: 'btn_make_default',
                    label: t('btn_make_default'),
                    checked: false,
                },
                {
                    value: 'btn_make_un_default',
                    label: t('btn_make_un_default'),
                    checked: false,
                },
            ],
        },
    ];
    return LISTA_PAGES;
};